'use strict';

export enum KeyboardCode {
  DownArrow = 40,
  UpArrow = 38,
  Enter = 13,
}
